import { render, staticRenderFns } from "./infoOther.vue?vue&type=template&id=4f7da94a&scoped=true"
import script from "./infoOther.vue?vue&type=script&lang=js"
export * from "./infoOther.vue?vue&type=script&lang=js"
import style0 from "./infoOther.vue?vue&type=style&index=0&id=4f7da94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7da94a",
  null
  
)

export default component.exports